module.exports = "/layout/app/images/bg-footer.05bea4f0.svg";